export var ContractRoles;
(function (ContractRoles) {
    ContractRoles["DEFAULT_ADMIN_ROLE"] = "DEFAULT_ADMIN_ROLE";
    ContractRoles["PAUSER_ROLE"] = "PAUSER_ROLE";
    ContractRoles["MINTER_ROLE"] = "MINTER_ROLE";
    ContractRoles["UPGRADER_ROLE"] = "UPGRADER_ROLE";
})(ContractRoles || (ContractRoles = {}));
export var PERSTokenContractTypes;
(function (PERSTokenContractTypes) {
    PERSTokenContractTypes["PERS_REWARD_TOKEN"] = "PERS_RewardToken";
    PERSTokenContractTypes["PERS_CREDIT_TOKEN"] = "PERS_CreditToken";
    PERSTokenContractTypes["PERS_STATUS_TOKEN"] = "PERS_StatusToken";
})(PERSTokenContractTypes || (PERSTokenContractTypes = {}));
